import { useCurrentDealerUserQuery } from 'api/partner/dealer_users';
import { usePartnerFetchLaboratoriesApi } from 'api/partner/laboratories';
import { usePartnerFetchOutsideLaboratoriesApi } from 'api/partner/outside_laboratories';
import { GlobalStateContext } from 'contexts/global_state_context';
import { PartnerStateContext } from 'contexts/partner_state_context';
import React, { useState, useContext, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { PartnerRouteHelper } from 'routes/partner';
import { bootChannelTalk, shutdownChannelTalk } from 'utils/channel_talk';
import CookieManager from 'utils/cookie_util';
import { useEffectSkipFirst } from 'utils/hooks';

const DealerUserAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(CookieManager.hasDealerUserToken());
  const globalState = useContext(GlobalStateContext);
  const partnerState = useContext(PartnerStateContext);
  const location = useLocation();

  const currentDealerUserQuery = useCurrentDealerUserQuery();
  const selectableOutsideLabApi = usePartnerFetchOutsideLaboratoriesApi({});
  const selectableLaboratoryApi = usePartnerFetchLaboratoriesApi({});

  useEffect(() => {
    currentDealerUserQuery.refetch();
    selectableOutsideLabApi.execute();
    selectableLaboratoryApi.execute();
  }, []);

  useEffectSkipFirst(() => {
    if (currentDealerUserQuery.isSuccess) {
      const dealer = currentDealerUserQuery.data.dealer;
      const dealerUser = currentDealerUserQuery.data.dealerUser;
      partnerState.setCurrentDealer(dealer);
      partnerState.setCurrentDealerUser(dealerUser);
      bootChannelTalk({
        pluginKey: process.env.REACT_APP_CHANNEL_PLUGIN_KEY,
        memberId: dealerUser.memberId,
        memberHash: dealerUser.memberHash,
        profile: {
          name: `${dealer.name} ${dealerUser.name}`,
          email: dealerUser.email,
          status: 'DealerUser',
          organization: `${dealer.name} ${dealer.branch}`,
          organizationId: dealer.id,
          organizationUrl: `${process.env.REACT_APP_PURCHASE_HOST}/admin/dealers/${dealer.id}`,
          agentLoginUrl: `${process.env.REACT_APP_PURCHASE_HOST}/admin/dealers/agents/${dealerUser.id}`,
          environment: process.env.REACT_APP_ENV,
        },
        workflowId: process.env.REACT_APP_CHANNEL_WORKFLOW_ID_DEALER_USER,
      });
    }
  }, [currentDealerUserQuery.dataUpdatedAt]);

  useEffectSkipFirst(() => {
    if (selectableOutsideLabApi.isSuccess() && selectableLaboratoryApi.isSuccess()) {
      partnerState.setSelectableOwners({
        laboratories: selectableLaboratoryApi.response.laboratories,
        outsideLaboratories: selectableOutsideLabApi.response.outsideLaboratories,
      });
    }
  }, [selectableOutsideLabApi.loading, selectableLaboratoryApi.loading]);

  useEffectSkipFirst(() => {
    if (globalState.statusCode === 401) {
      shutdownChannelTalk();
      CookieManager.removeDealerUserToken();
      setIsAuthenticated(false);
    } else if (CookieManager.hasDealerUserToken()) {
      setIsAuthenticated(true);
    }
  }, [globalState.statusCode]);

  return isAuthenticated ? (
    <div>
      <Outlet />
    </div>
  ) : (
    <Navigate to={PartnerRouteHelper.login()} state={{ from: location }} replace />
  );
};

export default DealerUserAuth;
